import { render, staticRenderFns } from "./UserArchivedChats.vue?vue&type=template&id=07913e0c&scoped=true&"
import script from "./UserArchivedChats.vue?vue&type=script&lang=js&"
export * from "./UserArchivedChats.vue?vue&type=script&lang=js&"
import style0 from "./UserArchivedChats.vue?vue&type=style&index=0&id=07913e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07913e0c",
  null
  
)

export default component.exports